module.exports = __webpack_public_path__ + "img/5_wind.10e9997b.jpg";